import EmployeeAvatar from "../employee-avatar/EmployeeAvatar";
import {Chip, ChipProps, Tooltip} from "@mui/material";
import React, {useCallback} from "react";
import {DeskRef, EmployeeRef} from "../../api/Model";
import {openHibobLink} from "../employee-link/EmployeeLink";
import {Opt} from "../../util/Optional";


export default function DeskChip({desk, deskAssignee, hideAssignee, outsideNeighbourhood, ...chipProps}: {
    desk: DeskRef,
    deskAssignee?: Opt<EmployeeRef>
    hideAssignee?: boolean,
    outsideNeighbourhood?: boolean,
} & ChipProps) {
    const handleClick = useCallback((event: React.MouseEvent<HTMLDivElement>) => {
        event.stopPropagation();
        if (deskAssignee) {
            openHibobLink(deskAssignee);
        }
    }, [deskAssignee]);

    const chip = (
        <Chip
            label={desk.name}
            avatar={(!hideAssignee && deskAssignee) ? <EmployeeAvatar employee={deskAssignee} showNameTooltip/> : undefined}
            onClick={handleClick}
            {...chipProps}
            color={outsideNeighbourhood ? 'warning' : chipProps.color ?? (deskAssignee ? 'default' : 'info')}
        />
    );

    return outsideNeighbourhood ? (
        <Tooltip title="This desk belongs to another neighbourhood">
            {chip}
        </Tooltip>
    ) : chip;
}
